import { render, staticRenderFns } from "./CopyOrderInfo.vue?vue&type=template&id=30932c46&scoped=true"
import script from "./CopyOrderInfo.vue?vue&type=script&lang=js"
export * from "./CopyOrderInfo.vue?vue&type=script&lang=js"
import style0 from "./CopyOrderInfo.vue?vue&type=style&index=0&id=30932c46&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "30932c46",
  null
  
)

export default component.exports